import { useState, useEffect, useCallback } from 'react';

/**
 * useDarkMode
 *
 * Light is the default. A visitor who chooses dark keeps it (localStorage,
 * key 'rbl-theme'). The choice is written two ways so both the Tailwind
 * dark: variants (.dark class) and the design tokens ([data-theme]) follow.
 */

const STORAGE_KEY = 'rbl-theme';

const getInitialTheme = () => {
  if (typeof window === 'undefined') return 'light';
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === 'dark' || saved === 'light') return saved;
  } catch (e) {
    /* storage unavailable; fall through to light */
  }
  return 'light';
};

const useDarkMode = () => {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
    root.setAttribute('data-theme', theme);
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* non-fatal */
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, toggleTheme, isDark: theme === 'dark' };
};

export default useDarkMode;
